import { styled } from '@linaria/react';
import { colors, space } from '../../theme/tokens';

export const Card = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.borderGreyLighter};
  border-radius: 12px;
  padding: ${space[5]};
`;
